var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        title: "타겟 인원 상세보기",
        size: "lg",
        "ok-title": "닫기",
        "ok-only": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        ok: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showTargetCountDetail,
        callback: function ($$v) {
          _vm.showTargetCountDetail = $$v
        },
        expression: "showTargetCountDetail",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "mb-md-0", attrs: { md: "8" } }, [
                _c("span", { staticClass: "text-primary" }, [
                  _vm._v("타겟 인원: "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm._f("$numberFormatter")(_vm.totalTargetCount)) +
                        "명 포함"
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-table-simple",
        {
          staticClass: "mt-2",
          staticStyle: { "max-height": "65vh", "font-size": "12px" },
          attrs: { bordered: "", responsive: "", "sticky-header": "" },
        },
        [
          _c("colgroup", [
            _c("col", { staticStyle: { width: "120px" } }),
            _c("col", { staticStyle: { width: "120px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
          ]),
          _c(
            "b-thead",
            { attrs: { "head-variant": "light" } },
            [
              _c(
                "b-tr",
                [
                  _c("b-th", [_vm._v("지역")]),
                  _c("b-th", [_vm._v("진료과")]),
                  _c("b-th", [_vm._v("타겟 인원(명)")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tbody",
            [
              _vm._l(_vm.data, function (region, rIdx) {
                return [
                  _vm._l(region.departments, function (dept, dIdx) {
                    return [
                      _c(
                        "b-tr",
                        {
                          key: "row-" + rIdx + "-" + dIdx,
                          style:
                            region.regionName === "(미분류제외) 전체 합"
                              ? "background-color: rgba(127, 127, 255, 0.1);"
                              : "",
                        },
                        [
                          _c(
                            "b-td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: dIdx === 0,
                                  expression: "dIdx === 0",
                                },
                              ],
                              attrs: { rowspan: region.departments.length + 1 },
                            },
                            [_vm._v(" " + _vm._s(region.regionName) + " ")]
                          ),
                          _c("b-td", [
                            _vm._v(
                              " " + _vm._s(dept.medicalDepartmentName) + " "
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("$numberFormatter")(dept.count)) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  }),
                  _c(
                    "b-tr",
                    {
                      key: "total-" + rIdx,
                      staticClass: "h6 font-weight-bolder",
                      staticStyle: {
                        "background-color": "rgba(127, 255, 127, 0.1)",
                      },
                    },
                    [
                      _c("b-td", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              region.regionName === "(미분류제외) 전체 합"
                                ? "전체 합계"
                                : "지역별 소계"
                            ) +
                            " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("$numberFormatter")(
                                region.regionTotalCount
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }